export const failsafesResin = {
    1: "LCD screen control system error",
    3: "Control board communication error",
    4: "LCD screen control system error",
    5: "Temperature of the UV lamp is too high.The cooling fan may be faulty",
    6: "An unexpected error has occurred in the application",
    7: "There is no firmware installed in the printer",
    8: "No connection with the control board",
    9: "The UV lamp fan has failed",
    10: "LCD screen control system error",
    11: "The printer is unable to detect the endstop",
    12: "The model exceeds the acceptable dimension in the Z axis",
    14: "The temperature sensor has failed or may be disconnected",
    15: "An error has occurred while updating the firmware",
    17: "LCD screen control system error",
    18: "Control board error"
}

export const failsafes = {
    1: "Upper fan: Not working",
    2: "Bottom fan: Not working",
    6: "Unexpected error",
    8: "Unable to communicate with the control board",
    21: "Hotend: Critical temperature",
    22: "Hotend: Temperature drop",
    23: "Hotend: Sensor failure",
    24: "Hotend: Heater failure",
    31: "Right Hotend: Critical temperature",
    32: "Right Hotend: Temperature drop",
    34: "Right Hotend: Heater failure",
    41: "Platform Heating Plate: Critical temperature",
    42: "Platform Heating Plate: Temperature drop",
    43: "Platform Heating Plate: Sensor failure",
    44: "Platform Heating Plate: Heater failure",
    55: "Endstop X: Homing failure",
    65: "Endstop Y: Homing failure",
    75: "Endstop Z: Homing failure",
    113: "Cap Sensor: Sensor failure",
    158: "Extruder PCB: No connection",
    210: "Hotend: Temperature fluctuation",
    310: "Right Hotend: Temperature fluctuation",
    410: "Platform Heating Plate: Temperature fluctuation",
    1511: "Extruder PCB: Overheating",
    1612: "Power Supply: Overheating",
    1713: "Motherboard: Overheating",
    2017: "Platform Small Connector: Not detected"
}
